module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enter_email_for_booking":"Enter email left for booking"},"zh":{"enter_email_for_booking":"輸入預約時填寫的 email"}}')
  delete Component.options._Ctor
}
